import { render, staticRenderFns } from "./CameraComp.vue?vue&type=template&id=48705035&scoped=true"
import script from "./CameraComp.vue?vue&type=script&lang=js"
export * from "./CameraComp.vue?vue&type=script&lang=js"
import style0 from "./CameraComp.vue?vue&type=style&index=0&id=48705035&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48705035",
  null
  
)

export default component.exports